// eslint-disable-next-line import/prefer-default-export
export function isMobile() {
  const isMobileUA = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
  const isSmallViewport = window.matchMedia('(max-width: 768px)').matches;
  return isMobileUA && isSmallViewport;
}
